import React, { ReactNode } from 'react';

import { useQuery } from '@apollo/client/react';

import { RoleScope } from '../graphql/__generated__/schema';
import { ViewerDocument } from '../graphql/__generated__/types';
import Rail from './Rail';

interface Props {
    children: ReactNode;
}

/**
 * Rail plus content. The `viewer` query is re-declared rather than threaded down
 * from `BackofficeGuard`: Apollo serves it from the cache, same query, same
 * variables, so this costs no request, and the rail stays readable on its own.
 */
const Layout = ({ children }: Props) => {
    const { data } = useQuery(ViewerDocument);

    const viewer = data?.viewer;
    const memberships = viewer?.memberships ?? [];
    // The internal membership, the one the guard checked. A staff member has exactly
    // one, on Freelance.com.
    const staff = memberships.find((membership) => membership?.role?.scope === RoleScope.Backoffice);

    const name = [viewer?.firstName, viewer?.lastName].filter(Boolean).join(' ') || (viewer?.email ?? '');

    return (
        <div className="flex min-h-screen">
            <Rail name={name} roleName={staff?.role?.name ?? ''} />
            {/* Le contenu occupe TOUTE la largeur, sur décision de Mohamed le
                2026-08-13, et c'est un choix qui en défait un autre : la colonne
                de 1 180 px venait du `.wrap` de la maquette, et le commentaire
                qui la tenait disait que la pleine largeur « faisait s'étaler les
                tableaux et mettait les actions d'une ligne à un écran de son
                nom ».

                Attention, cet argument n'est plus le même depuis, et c'est ce qui
                permet de le défaire plutôt que de l'ignorer. Le lecteur choisit
                désormais ses colonnes (PCG-135) et peut les redimensionner
                (PCG-159) : ce qui s'étalait sans recours se règle maintenant à la
                main, tandis que les bandes vides, elles, ne se réglaient pas. Une
                liste de comptes à dix colonnes défilait horizontalement au milieu
                d'un écran à moitié vide.

                Les marges restent : c'est la contrainte de largeur qui saute, pas
                l'air autour du contenu. */}
            <main className="min-w-0 flex-1">
                <div className="px-7 pb-16 pt-6">{children}</div>
            </main>
        </div>
    );
};

export default Layout;
